if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"web_assessment","remotes":[],"shareStrategy":"version-first"},
		chunkMatcher: function(chunkId) {return !/^(1(14|72|77)|344|367|588)$/.test(chunkId)},
		rootOutputDir: "",
		initialConsumes: undefined,
		bundlerRuntimeOptions: {}
	};
}